import { FC } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export interface PrivacyPolicyIconProps {
  color: string;
}

export const PrivacyPolicyIcon: FC<PrivacyPolicyIconProps> = ({ color }) => {
  return (
    <SvgIcon>
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M3.00753 5.25666C3.01394 4.96408 3.19289 4.70295 3.46361 4.59129L12.034 1.05576C12.2144 0.98142 12.4168 0.98142 12.597 1.05572L21.1725 4.59125C21.4445 4.70341 21.6238 4.96629 21.6288 5.26021C21.7383 11.7362 19.2638 18.4405 13.6971 22.1267C12.8687 22.6753 11.8567 22.7616 10.8981 22.214C8.44858 20.8146 2.7649 16.3809 3.00753 5.25666ZM4.47626 5.76873C4.41773 15.7455 9.43877 19.6896 11.6272 20.9319C12.0206 21.1552 12.5131 21.1418 12.8819 20.8976C17.8788 17.5886 20.1485 11.581 20.1554 5.76693L12.3157 2.53477L4.47626 5.76873Z'
          fill={color}
        />
        <path
          d='M14.7275 10.0182C14.7275 8.69459 13.6234 7.62158 12.2615 7.62158C10.8995 7.62158 9.79541 8.69459 9.79541 10.0182C9.79541 10.8015 10.1838 11.4948 10.7819 11.9321V15.513H13.7412V11.9321C14.3391 11.4948 14.7275 10.8015 14.7275 10.0182V10.0182Z'
          stroke={color}
          strokeWidth='1.5'
        />
      </svg>
    </SvgIcon>
  );
};
